import t, { useCallback as r, useMemo as e } from "react";
import n from "anchorme";
var o = function () {
  return o = Object.assign || function (t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) for (var o in r = arguments[e]) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    return t;
  }, o.apply(this, arguments);
};
function i(t, r) {
  var e = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && r.indexOf(n) < 0 && (e[n] = t[n]);
  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (e[n[o]] = t[n[o]]);
  }
  return e;
}
"function" == typeof SuppressedError && SuppressedError;
var u = /^((file:\/\/\/)|(https?:|ftps?:)\/\/|(mailto:))/i,
  a = function (t) {
    return function (t) {
      return u.test(t);
    }(t) ? "" : n.validate.email(t) ? "mailto:" : "http://";
  },
  c = function (r) {
    var e = r.href,
      n = r.linkComponent,
      u = r.truncate,
      c = i(r, ["href", "linkComponent", "truncate"]),
      l = null != n ? n : "a",
      p = a(e),
      f = u ? function (t, r) {
        if ("production" !== process.env.NODE_ENV && r <= 0) throw new Error("⚓️ maxLength should be positive number");
        return t.length > r ? t.substring(0, r) + "…" : t;
      }(e, u) : e;
    return /*#__PURE__*/t.createElement(l, o({}, c, {
      href: "".concat(p).concat(e)
    }), f);
  },
  l = /*#__PURE__*/t.memo(function (u) {
    var a = u.children,
      l = i(u, ["children"]),
      p = a,
      f = r(function () {
        var r = n.list(p);
        if (0 === r.length) return p;
        var e = [],
          i = 0;
        return r.forEach(function (r, n) {
          r.start > i && e.push(p.substring(i, r.start)), e.push( /*#__PURE__*/t.createElement(c, o({}, l, {
            key: n,
            href: r.string
          }))), i = r.end;
        }), p.length > i && e.push(p.substring(i)), 1 === e.length ? e[0] : e;
      }, [p, l]),
      s = e(function () {
        return f();
      }, [f]);
    return /*#__PURE__*/t.createElement(t.Fragment, null, s);
  });
export { l as Anchorme };